export const PRIMARY_BLUE = '#0679DF';
export const DASHBOARD_BLUE = '#0577DE';

export default {
  PRIMARY_BLUE,
  DASHBOARD_BLUE,
};
